import { Navigate } from "react-router-dom";
import { useVisitorRole } from "../utils/useVisitorRole";
import { VISITOR_LIST_SUBMODULE_SLUG } from "../utils/visitorPermissionSlugs";
import VisitorListPage from "./VisitorListPage";

/**
 * `/app/visitors` — Summary + own visitor directory (visitor-list; scope=self for all roles).
 */
export default function VisitorsHubPage() {
  const perms = useVisitorRole(VISITOR_LIST_SUBMODULE_SLUG);

  if (perms.permissionsLoading) {
    return (
      <div className="app-screen-guard app-screen-guard--loading">
        <p>Loading access…</p>
      </div>
    );
  }

  if (perms.canView) {
    return <VisitorListPage />;
  }

  return <Navigate to="/user-login" replace />;
}
